<template>
        <label :for="inputId" class="form-label">{{ $t(label) }}</label>
        <textarea :id="inputId" :name="name" class="form-control">{{ value }}</textarea>
</template>

<script>
export default {
    props: {
        label: String,
        type: String,
        value: String,
        name: String,
        placeholder: String,
        id: String, // Add the id prop
    },
    data() {
        return {
            inputId: this.id || this.generateUniqueId(), // Use id prop if provided, else generate unique ID
        };
    },
    methods: {
        generateUniqueId() {
            return `input_${Math.random().toString(36).substr(2, 9)}`;
        },
    },
};
</script>

<style scoped>
/* Add your component-specific styles here */
</style>
